var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('el-container',{staticStyle:{"height":"100vh"}},[_c('el-aside',{attrs:{"width":"200px"}},[_c('Aside')],1),_c('el-main',{staticStyle:{"padding-top":"0","padding-bottom":"0"}},[_c('Main')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }